export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9136.33fcb5a1.jpg";